module.exports = __webpack_public_path__ + "static/media/Icon__C.5e122c01.png";